import { format } from 'date-fns';
import Countdown from './Countdown';

interface TimeCountdownProps {
  expirationTime?: string;
  sessionLabel?: string;
  invoiceExpirationTime?: string;
  onGenerateNewSession?: () => void;
  isGeneratingSession?: boolean;
}

const TimeCountdown: React.FC<TimeCountdownProps> = ({
  expirationTime,
  sessionLabel,
  invoiceExpirationTime,
  onGenerateNewSession,
  isGeneratingSession,
}) => {
  return (
    <div className="flex w-full flex-col gap-1">
      {sessionLabel && (
        <span className="mb-1 text-sm font-medium text-gray-600">
          {sessionLabel}
        </span>
      )}
      <div className="flex w-full flex-col items-start justify-between gap-2 rounded-lg border border-gray-300 bg-gray-50 px-4 py-3 text-gray-700 transition-colors hover:text-gray-900 md:flex-row md:items-center">
        <div className="min-w-0 flex-1">
          <Countdown
            expirationTime={expirationTime}
            invoiceExpirationTime={invoiceExpirationTime}
            onGenerateNewSession={onGenerateNewSession}
            isGeneratingSession={isGeneratingSession}
          />
        </div>

        <div className="w-full text-left text-sm md:w-auto md:flex-shrink-0 md:text-right md:text-base">
          <span>
            {expirationTime
              ? format(new Date(expirationTime), "dd MMMM yyyy, HH:mm 'WIB'")
              : '-'}
          </span>
        </div>
      </div>
    </div>
  );
};

export default TimeCountdown;
